module.exports = __webpack_public_path__ + "img/Format-QandAs.e806105d.svg";